import React, { useEffect } from "react";

const GoogleTranslate = () => {
  useEffect(() => {
    const googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
        },
        "google_translate_element"
      );
    };

    // Attach the function to the window object to make it globally accessible
    window.googleTranslateElementInit = googleTranslateElementInit;

    const addScript = () => {
      const script = document.createElement("script");
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    };

    addScript();
  }, []);

  return (
    <div
      id="google_translate_element"
      style={{ overflow: "hidden", height: "24px" }}
    ></div>
  );
};

export default GoogleTranslate;
